import BaseModule from './BaseModule'

class Company extends BaseModule {
  constructor() {
    super()
  }
  // 获取公司信息
  getCompany(){
    return this.get(`/api/personal/company`)
  }
  //修改公司信息
  modifyCompany(params){
    return this.put(`/api/personal/company`,params)
  }
  //修改个人信息
  modifyAccount(params){
    return this.put(`/api/personal/account`,params)
  }
}

export default new Company()



// WEBPACK FOOTER //
// ./src/api/CompanyModule.js